export enum LOCAL_STORAGE_SYSTEMS {
  json = 1,
  IndexedDB = 2,
  SQLite = 3,
}
